enum ContentType {
  Show = 'Show',
  Episode = 'Episode',
  Movie = 'Movie',
  LinearChannel = 'LinearChannel',
  SportsFixture = 'SportsFixture',
  Collection = 'Collection',
  CollectionLink = 'CollectionLink',
  SectionLink = 'SectionLink',
  BrowseCollection = 'BrowseCollection',
  LinearSlot = 'LinearSlot',
}

export default ContentType;
